import React from 'react'
import { Box, IconButton, useColorModeValue } from '@chakra-ui/react';
import { Flex } from '@chakra-ui/react';
import { FiMenu } from 'react-icons/fi';
import { MainWrapperContext } from '.';
import { Switch } from 'react-router-dom';

export default function MainContextBox(props) {
    const { sidebar } = props;
    const { sidebarcomponent, switchcomponent } = React.useContext(MainWrapperContext);

    return (
        <Box ml={{ base: 0, md: 60 }} transition=".3s ease">
            <Flex
                as="header"
                align="center"
                justify="space-between"
                w="full"
                px="4"
                position="fixed"
                zIndex="10"
                bg={useColorModeValue('white', 'gray.800')}
                borderBottomWidth="1px"
                borderColor={useColorModeValue('inherit', 'gray.700')}
                h="14"
            >
                <IconButton
                    opacity={0}
                    aria-label="Menu"
                    display={{
                        base: 'inline-flex',
                        md: 'none',
                    }}
                    icon={<FiMenu />}
                    size="sm"
                />

                <IconButton
                    aria-label="Menu"
                    display={{
                        base: 'inline-flex',
                        md: 'none',
                    }}
                    onClick={sidebar.onOpen}
                    icon={<FiMenu />}
                    size="sm"
                />

                {/* Can probably keep this for search for jobs by name or smth */}
                {/* <InputGroup w="96" display={{ base: "none", md: "flex" }}>
                <InputLeftElement color="gray.500" children={<FiSearch />} />
                <Input placeholder="Search for articles..." />
            </InputGroup> */}
                {/* <Flex align="center">
                <Icon color="gray.500" as={FaBell} cursor="pointer" />
            </Flex> */}
            </Flex>

            <Box
                as="main"
                p="4"
                paddingBottom="40px"
                paddingTop="80px"
            >
                <Switch>{switchcomponent()}</Switch>
            </Box>
        </Box>


    )
}
